import { masterConfig as managerMasterConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/ppqManagerSection/masterConfig";

import { selectAndMergeCustomQuestionnaireConfigFactory } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { ApplicationState } from "../applicationState";

export const selectAndMergeManagerSectionQuestionnaireConfig = selectAndMergeCustomQuestionnaireConfigFactory<ApplicationState>(
    managerMasterConfig,
    (state) => state.questionnaireConfig.ppqManagerSection
);
